/** @jsxImportSource @emotion/react */
import InfoTip, {P} from './info-tip';

const ElasticWorkingTimeInfo = function () {
  return (
    <InfoTip
      info={
        <section css={{width: 415}}>
          <h3>彈性時間刻度</h3>
          <P>
            假設班表時間為09:00~18:00，上班時間往前彈性60分鐘，往後彈性60分鐘，
          </P>
          <P>
            1. 當打卡時間為09:11:
            <br />
            則刻度1時，即為彈性時間09:11~18:11。
            <br />
            則刻度5時，即為彈性時間09:15~18:15。
            <br />
            則刻度10時，即為彈性時間09:20~18:20。
            <br />
            則刻度15時，即為彈性時間09:15~18:15。
            <br />
            則刻度30時，即為彈性時間09:30~18:30。
            <br />
          </P>
          <P>
            2.當打卡時間為08:41:
            <br />
            則刻度1時，即為彈性時間08:41~17:41。
            <br />
            則刻度5時，即為彈性時間08:45~18:55。
            <br />
            則刻度10時，即為彈性時間08:50~17:50。
            <br />
            則刻度15時，即為彈性時間08:45~18:45。
            <br />
            則刻度30時，即為彈性時間09:00~18:00。
          </P>
        </section>
      }
    />
  );
};

export default ElasticWorkingTimeInfo;
